export const LANG_VAR_LOCAL_STORAGE_KEY = 'profeed_lang'

export const COLORS = {
  ORANGE: '#ff7200',
  RED: '#ff392a',
  GREEN: '#1da643',
  GREY: '#ddd'
}

export const ADMIN_SIDEBAR = [
  { id: 1, title: 'sidebar.users', path: 'users', icon: 'icon-man' },
  { id: 2, title: 'sidebar.group_access', path: 'groups', icon: 'icon-keys' },
  { id: 3, title: 'sidebar.animal_types', path: 'animal-types', icon: 'icon-cow' },
  { id: 4, title: 'sidebar.ingredient_types', path: 'ingredient-types', icon: 'icon-wheat' },
  { id: 5, title: 'sidebar.mixers', path: 'mixers', icon: 'icon-farm-mixer' },
  { id: 6, title: 'База міксерів', path: 'mixer-db', icon: 'icon-mixer-db' },
  { id: 7, title: 'base.blanks', path: 'blanks', icon: 'icon-farm-profile' },
]
export const EMPLOYEE_SIDEBAR = [
  { id: 3, title: 'sidebar.animal_types', path: 'animal-types', icon: 'icon-cow' },
  { id: 4, title: 'sidebar.ingredient_types', path: 'ingredient-types', icon: 'icon-wheat' },
  { id: 5, title: 'sidebar.mixers', path: 'mixers', icon: 'icon-farm-mixer' },
  { id: 6, title: 'base.blanks', path: 'blanks', icon: 'icon-farm-profile' },
]
